import { fetchWithToken } from "../../../api/apiutils";

const subscriptionTypeMap = {
  "Обычный пользователь": "Default",
  "Демо подписка": "Trial",
  "Colibri PRO": "Pro",
  "Просрочена подписка": "Expried",
};

function buildParamsFromQuery(query) {
  const { filters = {}, page = 1, pageLimit = 10, dynamicDate } = query || {};
  const params = new URLSearchParams();

  params.set("page", String(page));
  params.set("pageLimit", String(pageLimit));

  if (dynamicDate) {
    params.set("ActionDateFrom", dynamicDate);
  }

  if (filters.registerDateFrom)
    params.set("RegisterDateFrom", filters.registerDateFrom);
  if (filters.registerDateTo)
    params.set("RegisterDateTo", filters.registerDateTo);

  if (filters.isSubscribed) params.set("IsSubscribed", "true");

  if (filters.subscriptionActivatedFrom)
    params.set("Subscription.ActivedFrom", filters.subscriptionActivatedFrom);
  if (filters.subscriptionActivatedTo)
    params.set("Subscription.ActivedTo", filters.subscriptionActivatedTo);

  if (filters.subscriptionType) {
    const mapped =
      subscriptionTypeMap[filters.subscriptionType] || filters.subscriptionType;
    params.set("Subscription.Type", mapped);
  }

  if (filters.activityLevel) params.set("ActivityLevel", filters.activityLevel);

  if (Array.isArray(filters.segmentCodes) && filters.segmentCodes.length > 0) {
    params.set("SegmentCodes", filters.segmentCodes.join(","));
  }

  if (filters.search && String(filters.search).trim().length > 0) {
    params.set("search", String(filters.search).trim());
  }

  return params;
}

export async function getActiveUsers(query) {
  const params = buildParamsFromQuery(query);
  const url = `/api/dashboard?${params.toString()}`;

  const res = await fetchWithToken(url);
  if (!res.ok) throw new Error("Не удалось получить данные");
  const data = await res.json();
  return {
    items: data?.data || [],
    total: data?.all ?? (Array.isArray(data?.data) ? data.data.length : 0),
  };
}

export async function getActiveUsersForExport(query) {
  const q = { ...(query || {}), page: 1, pageLimit: 10000 };
  const params = buildParamsFromQuery(q);
  const url = `/api/dashboard?${params.toString()}`;

  const res = await fetchWithToken(url);
  if (!res.ok) throw new Error("Не удалось получить данные для экспорта");
  return res.json();
}
